import {SkillDetail} from './SkillDetail.ts';

export const skills: SkillDetail[] = [
    {
        title: 'Java',
        description: 'Programming Language',
        link: 'https://www.java.com/',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/java.png',
        bgColor: 'rgba(255,237,219,1)'
    },
    {
        title: 'C++',
        description: 'Programming Language',
        link: 'https://www.cplusplus.com/',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/cpp.png',
        bgColor: 'rgba(204,229,255,1)'
    },
    {
        title: 'C',
        description: 'Programming Language',
        link: 'https://en.wikipedia.org/wiki/C_(programming_language)',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/c.png',
        bgColor: 'rgba(234,239,255,1)'
    },
    {
        title: 'JavaScript',
        description: 'Programming Language',
        link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/javascript.png',
        bgColor: 'rgba(253,248,220,1)'
    },
    {
        title: 'TypeScript',
        description: 'Programming Language',
        link: 'https://www.typescriptlang.org/',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/typescript.png',
        bgColor: 'rgba(204,224,255,1)'
    },
    {
        title: 'React',
        description: 'JavaScript Library',
        link: 'https://reactjs.org/',
        categories: ['library', 'frontend development'],
        imageRefs: '/assets/images/skills/react.png',
        bgColor: 'rgba(240,255,255,1)'
    },
    {
        title: 'MongoDB',
        description: 'NoSQL Database',
        link: 'https://www.mongodb.com/',
        categories: ['database'],
        imageRefs: '/assets/images/skills/mongodb.png',
        bgColor: 'rgba(210,255,220,1)'
    },
    {
        title: 'Bootstrap',
        description: 'CSS Framework',
        link: 'https://getbootstrap.com/',
        categories: ['framework', 'frontend development'],
        imageRefs: '/assets/images/skills/bootstrap.png',
        bgColor: 'rgba(220,220,255,1)'
    },
    {
        title: 'JUnit',
        description: 'Testing Framework',
        link: 'https://junit.org/junit5/',
        categories: ['framework', 'backend development'],
        imageRefs: '/assets/images/skills/junit.png',
        bgColor: 'rgba(204,255,228,1)'
    },
    {
        title: 'Mocha',
        description: 'Testing Framework',
        link: 'https://mochajs.org/',
        categories: ['framework', 'backend development'],
        imageRefs: '/assets/images/skills/mocha.png',
        bgColor: 'rgba(235,215,215,1)'
    },
    {
        title: 'Chai',
        description: 'Assertion Library',
        link: 'https://www.chaijs.com/',
        categories: ['library', 'backend development'],
        imageRefs: '/assets/images/skills/chai.png',
        bgColor: 'rgba(235,215,215,1)'
    },
    {
        title: 'Tableau',
        description: 'Data Visualization Tool',
        link: 'https://www.tableau.com/',
        categories: ['data visualization'],
        imageRefs: '/assets/images/skills/tableau.png',
        bgColor: 'rgba(255,240,220,1)'
    },
    {
        title: 'SOQL',
        description: 'Object Query Language',
        link: 'https://developer.salesforce.com/docs/atlas.en-us.soql_sosl.meta/soql_sosl/sforce_api_calls_soql.htm',
        categories: ['programming language', 'database'],
        imageRefs: '/assets/images/skills/salesforce.png',
        bgColor: 'rgba(204,225,255,1)'
    },
    {
        title: 'Apex',
        description: 'Programming Language',
        link: 'https://developer.salesforce.com/docs/atlas.en-us.apexcode.meta/apexcode/apex_intro.htm',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/salesforce.png',
        bgColor: 'rgba(204,225,255,1)'
    },
    {
        title: 'R',
        description: 'Programming Language',
        link: 'https://www.r-project.org/',
        categories: ['programming language', 'data science'],
        imageRefs: '/assets/images/skills/r.png',
        bgColor: 'rgba(204,227,255,1)'
    },
    {
        title: 'Docker',
        description: 'Containerization Tool',
        link: 'https://www.docker.com/',
        categories: ['devops'],
        imageRefs: '/assets/images/skills/docker.png',
        bgColor: 'rgba(204,230,255,1)'
    },
    {
        title: 'Google Analytics',
        description: 'Web Analytics',
        link: 'https://analytics.google.com/analytics/web/',
        categories: ['data visualization'],
        imageRefs: '/assets/images/skills/google-analytics.png',
        bgColor: 'rgba(255,226,204,1)'
    },
    {
        title: 'Python',
        description: 'Programming Language',
        link: 'https://www.python.org/',
        categories: ['programming language'],
        imageRefs: '/assets/images/skills/python.png',
        bgColor: 'rgba(204,225,255,1)'
    },
    {
        title: 'JetBrains Suite',
        description: 'Code Editor Suite',
        link: 'https://www.jetbrains.com/',
        categories: ['development tools'],
        imageRefs: '/assets/images/skills/jetbrains.png',
        bgColor: 'rgba(229,204,255,1)'
    },
    {
        title: 'VS Code',
        description: 'Source Code Editor',
        link: 'https://code.visualstudio.com/',
        categories: ['development tools'],
        imageRefs: '/assets/images/skills/vscode.png',
        bgColor: 'rgba(204,227,255,1)'
    },
    {
        title: 'AWS Fargate',
        description: 'Serverless Compute',
        link: 'https://aws.amazon.com/fargate/',
        categories: ['devops', 'cloud computing'],
        imageRefs: '/assets/images/skills/aws.png',
        bgColor: 'rgba(255,234,204,1)'
    },
    {
        title: 'AWS Lambda',
        description: 'Serverless Compute',
        link: 'https://aws.amazon.com/lambda/',
        categories: ['devops', 'cloud computing'],
        imageRefs: '/assets/images/skills/aws.png',
        bgColor: 'rgba(255,234,204,1)'
    },
    {
        title: 'DynamoDB',
        description: 'NoSQL Database Service',
        link: 'https://aws.amazon.com/dynamodb/',
        categories: ['database', 'cloud computing'],
        imageRefs: '/assets/images/skills/aws.png',
        bgColor: 'rgba(255,234,204,1)'
    },
    {
        title: 'JSON Web Tokens',
        description: 'Authentication',
        link: 'https://jwt.io/',
        categories: ['backend development', 'security'],
        imageRefs: '/assets/images/skills/jwt.png',
        bgColor: 'rgba(204,204,204,1)'
    },
    {
        title: 'Google OAuth',
        description: 'Authorization Framework',
        link: 'https://developers.google.com/identity/protocols/oauth2',
        categories: ['backend development', 'security'],
        imageRefs: '/assets/images/skills/google.png',
        bgColor: 'rgba(255,235,235,1)'
    },
    {
        title: 'Language Servers',
        description: 'Protocol for IDEs',
        link: 'https://microsoft.github.io/language-server-protocol/',
        categories: ['development tools'],
        imageRefs: '/assets/images/skills/microsoft.png',
        bgColor: 'rgba(204,227,255,1)'
    },
    {
        title: 'Chakra UI',
        description: 'React Component Library',
        link: 'https://chakra-ui.com/',
        categories: ['library', 'frontend development'],
        imageRefs: '/assets/images/skills/chakraui.png',
        bgColor: 'rgba(210,240,240,1)'
    },
    {
        title: 'Redux',
        description: 'State Management',
        link: 'https://redux.ts.org/',
        categories: ['library', 'frontend development'],
        imageRefs: '/assets/images/skills/redux.png',
        bgColor: 'rgba(240,220,255,1)'
    },
    {
        title: 'PostgreSQL',
        description: 'Relational Database',
        link: 'https://www.postgresql.org/',
        categories: ['database'],
        imageRefs: '/assets/images/skills/postgresql.png',
        bgColor: 'rgba(204,227,255,1)'
    },
    {
        title: 'Mockito',
        description: 'Mocking Framework',
        link: 'https://site.mockito.org/',
        categories: ['testing', 'backend development'],
        imageRefs: '/assets/images/skills/mockito.jpeg',
        bgColor: 'rgba(242,242,204,1)'
    },
    {
        title: 'HTML5',
        description: 'Markup Language',
        link: 'https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5',
        categories: ['frontend development'],
        imageRefs: '/assets/images/skills/html-5.png',
        bgColor: 'rgba(255,240,240,1)'
    },
    {
        title: 'CSS3',
        description: 'Styling Language',
        link: 'https://developer.mozilla.org/en-US/docs/Archive/CSS3',
        categories: ['frontend development'],
        imageRefs: '/assets/images/skills/css3.png',
        bgColor: 'rgba(220,240,255,1)'
    },
    {
        title: 'Heroku',
        description: 'Cloud Platform as a Service',
        link: 'https://www.heroku.com/',
        categories: ['cloud computing', 'devops'],
        imageRefs: '/assets/images/skills/heroku.png',
        bgColor: 'rgba(240,240,255,1)'
    },
    {
        title: 'OpenAI API',
        description: 'Natural Language Processing',
        link: 'https://www.openai.com/',
        categories: ['API', 'machine learning', 'NLP'],
        imageRefs: '/assets/images/skills/openai.png',
        bgColor: 'rgba(197, 229, 220, 1)'
    }
];
